import React, { useEffect, useRef, useState } from "react";
import { Form, Input, Modal, Select, Spin } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { save } from "../../../../features/save/saveSlice";
import {
  fetchActiveFiscMonth,
  fetchActiveFiscYear,
  fetchPayrollType,
} from "../../../../features/dropdown/dropdownSlice";
import svg57 from "../../../../assets/svg/svg57.svg";
import ConfirmSubmitModal from "../../../../components/ConfirmSubmitModal";

const { TextArea } = Input;

const PeriodModal = ({
  open,
  handleCancel,
  handleFetchData,
  prodd,
  setopenPeriod,
}) => {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { user } = useSelector((state) => state.auth);
  const { saving } = useSelector((state) => state.save);
  const { activeFiscYear, loading, activeFiscMonth, payrollType } = useSelector(
    (state) => state.dropdown
  );
  const [data, setData] = useState({});

  const [formData, setFormData] = useState(prodd);

  const onChange = async (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  function handleSelectChange(value, formName) {
    setFormData((prevData) => ({
      ...prevData,
      [formName]: value,
    }));
  }

  const [isModalOpenSubmit, setIsModalOpenSubmit] = useState(false);
  const handleConfirmation = async () => {
    await setIsModalOpenSubmit(true);
    await setopenPeriod(false);
  };
  const handleReturnPeriod = async () => {
    await setIsModalOpenSubmit(false);
    await setopenPeriod(true);
  };

  const onFinish = async (data) => {
    if(!formData?.fpPyear){
      toast.error("Select a year")
      return;
    }
    if(!formData?.fpPmonth){
      toast.error("Select a month")
      return;
    }
    const res = await dispatch(
      save({
        url: `hr/savePeriodEnd.action?fpPyear_id=${formData?.fpPyear}&fpPmonth_id=${formData?.fpPmonth}`,
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.messages?.message);
      await handleFetchData();
      await setFormData({});
      await handleCancel();
      await setIsModalOpenSubmit(false);
      await form.resetFields();
    } else {
      toast.error(res?.payload?.messages?.message);
    }
  };

  async function fetchActiveFiscYearData() {
    dispatch(fetchActiveFiscYear());
  }

  async function fetchActiveFiscMonthData() {
    dispatch(fetchActiveFiscMonth());
  }

  return (
    <>
      <Modal
        className="modal-btn mod-height mod-footer"
        title="Period End Processing"
        open={open}
        onOk={handleConfirmation}
        onCancel={handleCancel}
        width={850}
      >
        <Form
          layout="vertical"
          ref={formRef}
          name="control-ref"
          onFinish={handleConfirmation}
          className=" "
          style={{
            maxWidth: "100%",
          }}
          form={form}
        >
          <Form.Item
            className=""
            label="Period Year"
            rules={[
              {
                required: true,
                message: "Please select period year ",
              },
            ]}
          >
            <Select
              name="fpPyear"
              value={formData?.fpPyear}
              onChange={(value) => {
                handleSelectChange(value, "fpPyear");
              }}
              className=""
              allowClear
              style={{
                width: "100%",
              }}
              options={
                activeFiscYear?.length > 0 &&
                activeFiscYear?.map((item) => ({
                  value: item?.fpPyear,
                  label: item?.fpPyear,
                }))
              }
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.label?.toLocaleLowerCase() ?? "").includes(
                  input?.toLocaleLowerCase()
                )
              }
              onDropdownVisibleChange={() => {
                fetchActiveFiscYearData();
              }}
              dropdownRender={(menu) => (
                <>
                  {loading && (
                    <div
                      style={{
                        padding: "8px",
                        textAlign: "center",
                      }}
                    >
                      <Spin className="sms-spin" />
                    </div>
                  )}
                  {menu}
                </>
              )}
            />
          </Form.Item>

          <Form.Item
            className=""
            label="Period Month"
            rules={[
              {
                required: true,
                message: "Please select period month ",
              },
            ]}
          >
            <Select
              name="fpPmonth"
              value={formData?.fpPmonth}
              onChange={(value) => {
                handleSelectChange(value, "fpPmonth");
              }}
              className=""
              allowClear
              style={{
                width: "100%",
              }}
              options={
                activeFiscMonth?.length > 0 &&
                activeFiscMonth?.map((item) => ({
                  value: item?.fpPmonth,
                  label: item?.fpPmonth,
                }))
              }
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.label?.toLocaleLowerCase() ?? "").includes(
                  input?.toLocaleLowerCase()
                )
              }
              onDropdownVisibleChange={() => {
                fetchActiveFiscMonthData();
              }}
              dropdownRender={(menu) => (
                <>
                  {loading && (
                    <div
                      style={{
                        padding: "8px",
                        textAlign: "center",
                      }}
                    >
                      <Spin className="sms-spin" />
                    </div>
                  )}
                  {menu}
                </>
              )}
            />
          </Form.Item>

          <div className="flex lg:flex-row flex-col justify-between mt-[56px] mb-[48px]">
            <div className="justify-start"></div>
            <div className="justify-end flex items-center gap-x-2">
              <div className="w-[200px]">
                <button
                  key="back"
                  type="button"
                  onClick={handleCancel}
                  className="cstm-btn !bg-white !text-lightBlack !border !border-lightBlack"
                >
                  Cancel
                </button>
              </div>

              <div className="w-[200px]">
                <button
                  key="submit"
                  type="submit"
                  className="cstm-btn flex gap-x-3"
                  disabled={saving}
                >
                  <img src={svg57} alt="svg57" />
                  {saving ? <Spin /> : "Process"}
                </button>
              </div>
            </div>
          </div>
        </Form>
      </Modal>

      <ConfirmSubmitModal
        isModalOpen={isModalOpenSubmit}
        setIsModalOpen={setIsModalOpenSubmit}
        handleSubmit={onFinish}
        loading={saving}
        content={`Are you sure you want to stop this period processing?`}
        handleReturnPeriod={handleReturnPeriod}
        back={true}
      />
    </>
  );
};
export default PeriodModal;
